export default __webpack_public_path__ + "static/media/Be-Productive.1c9873b9.jpg";